/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Tenant switch request
 * @export
 * @interface SwitchTenantRequest
 */
export interface SwitchTenantRequest {
    /**
     * 
     * @type {string}
     * @memberof SwitchTenantRequest
     */
    tenantId?: string;
}

/**
 * Check if a given object implements the SwitchTenantRequest interface.
 */
export function instanceOfSwitchTenantRequest(value: object): value is SwitchTenantRequest {
    return true;
}

export function SwitchTenantRequestFromJSON(json: any): SwitchTenantRequest {
    return SwitchTenantRequestFromJSONTyped(json, false);
}

export function SwitchTenantRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SwitchTenantRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
    };
}

export function SwitchTenantRequestToJSON(json: any): SwitchTenantRequest {
    return SwitchTenantRequestToJSONTyped(json, false);
}

export function SwitchTenantRequestToJSONTyped(value?: SwitchTenantRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenant_id': value['tenantId'],
    };
}

